<template>
  <div
    class="cbg-white-container blog-listing-main input-container theme--light v-card p-16 border-card"
  >
    <div class="col-sm-12 row ml-0 pl-0 pr-0">
      <div class="row">
        <CCol sm="6" md="3">
          <label for>Search</label>
          <div class="search-div position-relative">
            <input
              class="form-control"
              placeholder="Search"
              @input="debounceSearch()"
              v-model="search"
            />
            <div v-if="search !== ''" class="search-svg position-absolute" @click="clearSearch()">
              <crossSVG />
            </div>
          </div>
        </CCol>
        <CCol sm="6" md="3" class="datepicker pos-r">
          <label for>Date Range (Created Date)</label>
          <datepicker
            v-model="dateRange"
            @input="dateChange()"
            ref="datepicker"
            :model-config="datePickerConfig"
            :max-date="new Date()"
            is-range
            :masks="{ input: 'DD-MM-YYYY' }"
          >
            <template v-slot="{ inputValue, inputEvents }">
              <input
                :value="
                  !!inputValue.start && !!inputValue.end
                    ? inputValue.start + ' - ' + inputValue.end
                    : 'DD/MM/YYYY'
                "
                v-on="inputEvents.start"
                class="form-control position-relative"
                placeholder="DD-MM-YYYY"
              />

              <div
                v-if="!!inputValue.start && !!inputValue.end"
                class="cross-svg"
                @click="resetActiveDate"
              >
                <crossSVG />
              </div>
            </template>
          </datepicker>
          <div class="calendarsvg userinputcalendar pos-a">
            <calendarSVG />
          </div>
        </CCol>
        <CCol sm="6" md="3">
          <div class="position-relative">
            <label for>Blog Status</label>
            <select name id v-model="blogStatus" class="form-control">
              <option value="all">All</option>
              <option value="published">Published</option>
              <option value="unpublished">Unpublished</option>
              <option value="draft">Drafts</option>
            </select>
            <span class="drop-icon">
              <i aria-hidden="true" class="v-icon mdi mdi-menu-down theme--light position-absolute"></i>
            </span>
          </div>
        </CCol>
        <!-- <CCol sm="6" md="3">
          <div>
            <label for>Blog Type</label>
            <select name id class="form-control" v-model="blogType">
              <option value="all">All</option>
              <option value="admin">My Blogs</option>
              <option value="user">User Blogs</option>
            </select>
          </div>
        </CCol>-->
        <CCol sm="6" md="3">
          <div class="mt-7 xs-mt-0">
            <v-btn
              v-if="permissions.includes('CAN_CREATE_ADMIN_BLOGS')"
              color="success"
              @click="goTo('/createBlog')"
            >Create Blog</v-btn>
          </div>
        </CCol>
        <!-- <CCol sm="12" md="12" class="flex-end mob-f-s flex-dir-col">
          <v-btn
            v-if="permissions.includes('CAN_CREATE_ADMIN_BLOGS')"
            color="success"
            @click="goTo('/createBlog')"
            >Create Blog</v-btn
          >
        </CCol>-->
      </div>
    </div>

    <div v-if="blogList.length > 0" class="col-sm-12 row ml-0 mt-6 p-0 userlistTable-typ1 mb-5">
      <blogCard
        v-for="(blog, i) in blogList"
        :key="i"
        :blogDetails="blog"
        @refreshList="getBlogList()"
      />
    </div>
    <div v-else-if="showLoader && blogList.length === 0">
      <loader v-if="showLoader"></loader>
    </div>
    <div v-else-if="isEmpty" class="pt-4 no-data-class">
      <h2 class="text-center">No Data Found</h2>
    </div>
    <pagination
      class="pagination-block"
      v-if="blogList.length > 0"
      :recordPerPage="recordPerPage"
      :currentPage="currentPage"
      :total="total"
      @changePage="changePage"
    />
  </div>
</template>
<script>
import config from "@/config.js";
import debounce from "lodash/debounce";
import { mapGetters } from "vuex";
import "@/assets/scss/_blogs.scss";
const Datepicker = () => import("v-calendar/lib/components/date-picker.umd");
const blogCard = () => import("@/views/blogs/blogCard");
const loader = () => import("@/components/loader.vue");
import { pickSvg } from "@/views/SVG";
export default {
  computed: {
    ...mapGetters({
      permissions: "getPermissions"
    })
  },
  data() {
    return {
      datePickerConfig: {
        start: {
          timeAdjust: "00:00:00"
        },
        end: {
          timeAdjust: "23:59:59"
        }
      },
      dateRange: {
        start: "",
        end: ""
      },
      recordPerPage: 12,
      currentPage: 1,
      totalPage: 1,
      total: 0,
      blogList: [],
      blogType: "admin",
      blogStatus: "all",
      search: "",
      showLoader: false,
      isEmpty: false
    };
  },
  mounted() {
    if (!!this.$route.params.tag) {
      this.search = this.$route.params.tag;
      this.getBlogList();
    } else {
      this.getBlogList();
    }
  },
  watch: {
    blogStatus: {
      handler(newValue) {
        this.blogList = [];
        this.getBlogList();
      }
    },
    blogType: {
      handler(newValue) {
        this.blogList = [];
        this.getBlogList();
      }
    }
  },
  components: {
    loader,
    blogCard,
    Datepicker,
    pagination: () => import("@/views/common/Pagination"),
    ...pickSvg("crossSVG")
  },
  methods: {
    resetActiveDate() {
      this.dateRange = { start: "", end: "" };
      this.getBlogList();
    },
    changePage(page) {
      this.currentPage = page.currentPage;
      this.getBlogList();
    },
    debounceSearch: debounce(function() {
      this.getBlogList();
    }, 500),
    changeStatus() {
      this.getBlogList();
    },
    dateChange() {
      this.getBlogList();
    },
    getBlogList() {
      this.showLoader = true;
      this.total = 0;
      let url = `${config.BASE_URL}api/v2/admin/blogs`;
      let params = {
        page: this.currentPage,
        records_per_page: this.recordPerPage,
        blog_type: this.blogType,
        blog_status: this.blogStatus,
        search: this.search,
        start_date: this.dateRange.start.toString(),
        end_date: this.dateRange.end.toString()
      };
      this.$http.get(url, { params }).then(response => {
        if (response.body.status) {
          this.showLoader = false;
          if (response.body.data.list.length) {
            this.blogList = response.body.data.list;
            this.totalPage = response.body.data.count / this.recordPerPage;
            if (response.body.data.count % this.recordPerPage !== 0)
              this.totalPage = parseInt(JSON.stringify(this.totalPage)) + 1;
            this.total = response.body.data.count;
          } else {
            this.blogList = [];
            this.isEmpty = true;
          }
        }
      });
    },
    clearSearch() {
      this.search = "";
    },
    goTo(url) {
      this.$router.push(url);
    }
  }
};
</script>
<style scoped>
.blog-listing-main{
  height: unset !important;
}
</style>